import { createAction } from 'redux-create-action';
import { ACTIONS } from './constants';


export const fetchReturns = createAction(
  ACTIONS.FETCH_RETURNS,
  'params',
  'successActionCallback',
  'errorActionCallback',
);
export const fetchReturnsReportCSV = createAction(
  ACTIONS.FETCH_RETURNS_CSV,
  'params',
  'successActionCallback',
  'errorActionCallback',
);

export const postAddNewReturn = createAction(
  ACTIONS.POST_ADD_NEW_RETURN,
  'params',
  'successActionCallback',
  'errorActionCallback',
);
